import Config from '../../../Config';
import {prepareUrl} from '../../../utilities/StringHelpers/StringHelpers';
import {isMobile} from 'react-device-detect';

export const getDateFromISO = (isoDate) => {
  if(!isoDate){
    return "";
  }
  let dateArr = isoDate?.substring(0, 10).split('-');
  let day = dateArr[2];
  let month = dateArr[1];
  let year = dateArr[0];

  return [day, month, year].join('.');
};

export const getFullPath = (relativePath) => {
  return relativePath ? Config.epiBaseUrl + relativePath : relativePath;
};

export const extractIconElements = (editorList) => {

  return editorList?.map((element) => {
    if (element?.image) {
      return {
        image: getFullPath(element?.image?.value?.url),
        socialNetworkId: element?.socialNetwork?.value,
      };
    }
  }) || [];
};

export const extractTagsElements = (editorList) => {

  return editorList?.map((element) => {
    return {
      tagText: element?.tag?.value,
      link: element?.tagLink?.value,
    };
  }) ||[];
};

export const extractAdditionalArticlesElements = (editorList) => {
  return editorList?.map((element) => {
    let imgPath = isMobile ? element?.articleImageMobile?.value?.url : element?.articleImageDesktop?.value?.url;
    return {
      articleImage: getFullPath(imgPath),
      heading: element?.heading?.value,
      articleDate: getDateFromISO(element?.articleDate?.value),
      publisher: element?.publisher?.value,
      articleContent: element?.articleContent?.value,
      articleLink: element?.articleLink?.value,
    };
  }) || [];
};

export const handleClick = (btnPath, context) => {
  context.navigateTo(btnPath);
};

export const shareToSocialNetwork = (socialNetworkNum) => {
  const url = window.location.href;

  if (!socialNetworkNum) {
    return url;
  }

  const socialNetworkUrls = {
    1: `https://api.whatsapp.com/send?text=${encodeURIComponent(url)}`,
    2: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    3: `https://twitter.com/share?url=${encodeURIComponent(url)}`
  };

  return socialNetworkUrls[socialNetworkNum] || url;
};

export const iframeScreenAdjustment = (articleContent, measurments) => {
  return articleContent?.indexOf('allowfullscreen') > -1
    ? articleContent?.replace('allowfullscreen', `${measurments} allowfullscreen`)
    : articleContent;
};

export const extractAdditionalArticlesTvElements = (editorList) => {
  return editorList?.map((element) => {
    let imgPath = isMobile ? element?.articleImageMobile?.value?.url : element?.articleImageDesktop?.value?.url;
    return {
      articleImage: getFullPath(imgPath),
      heading: element.heading?.value,
      articleContent: element.articleContent?.value,
      articleLink: element.articleLink?.value,
    };
  }) || [];
};
